import Vue from 'vue';
import Vuex from 'vuex'

Vue.use(Vuex);

const getStoredUser = () => {
	try {
		return window.localStorage.user ? JSON.parse(window.localStorage.user) : '';
	} catch {
		window.localStorage.removeItem('user');
		return '';
	}
};

export default new Vuex.Store({
	state: {
		apiUrl: `http://${window.location.hostname}:${process.env.VUE_APP_API_PORT}/api/`,
		proveedorUrl: `http://${window.location.hostname}:${process.env.VUE_APP_API_PORT}/proveedores/`,
		filesUrl: `http://${window.location.hostname}:${process.env.VUE_APP_ASSET_PORT}/`,
		user: getStoredUser()
	},
	mutations: {
    updateUser(state, newUserData) {
      state.user = { ...state.user, ...newUserData };
      window.localStorage.setItem('user', JSON.stringify(state.user));
    }
  },
});
